import { gql } from '@common/hooks';

export type AppSearchWorksProfileFragmentType = {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
};

export const AppSearchWorksProfileFragment = gql`
  fragment AppSearchWorksProfileFragment on WorksProfile {
    id
    firstName
    lastName
    email
    fullName
  }
`;
